import { useRegisterDevice } from '@/features/notifications/hooks/useRegisterDevice';
import { Button } from '@/shared/components/ui/button';
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
  type ResponsiveDialogProps,
  ResponsiveDialogTitle,
} from '@/shared/components/ui/custom/responsive-dialog';
import { getPlatform } from '@/shared/utils/platform';

export type PlayNowNotificationsModalProps = ResponsiveDialogProps & {
  onComplete?: () => void;
};

export function PlayNowNotificationsModal(
  props: PlayNowNotificationsModalProps,
) {
  const { open, onOpenChange, onComplete, ...rest } = props;
  const { mutateAsync, isPending } = useRegisterDevice();

  const handleEnableNotifications = async () => {
    try {
      await mutateAsync({
        platform: getPlatform(),
        source: 'play_now_modal',
      });
      onComplete?.();
      onOpenChange?.(false);
    } catch {
      // Error toast is handled by useRegisterDevice
    }
  };

  return (
    <ResponsiveDialog open={open} onOpenChange={onOpenChange} {...rest}>
      <ResponsiveDialogContent>
        <ResponsiveDialogHeader>
          <ResponsiveDialogTitle>
            Enable notifications to keep using Play Now
          </ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            Play Now works with instant alerts so no one waits.
            <br />
            Enable notifications so you don't miss your next duo or leave
            someone waiting.
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>
        <ResponsiveDialogFooter>
          <Button
            className="w-full"
            onClick={handleEnableNotifications}
            disabled={isPending}
          >
            {isPending ? 'Enabling...' : 'Enable notifications'}
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
}
